module.exports = __webpack_public_path__ + "img/btn_left.9c9c7df8.png";